import React from 'react';

import Grid, { GridProps } from '../Grid';

const FormRaw: React.FC<GridProps> = ({ children, ...rest }) => (
  <Grid item {...rest}>
    {children}
  </Grid>
);

export { FormRaw };
